import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { ConfirmDialogComponent } from '@shared/components/confirm-dialog/confirm-dialog.component';
import { ToastContainerComponent } from '@shared/components/toast/toast.component';
import { StoreConfigService } from '@core/services/store-config.service';

@Component({
  selector: 'app-main-layout',
  imports: [RouterOutlet, RouterLink, HeaderComponent, FooterComponent, ToastContainerComponent, ConfirmDialogComponent],
  template: `
    @switch (storeConfig.status()) {
      @case ('loading') {
        <!-- Neutro a propósito: ni colores FAISEN ni maquetación por defecto antes de saber cómo es la tienda. -->
        <main class="min-h-screen flex items-center justify-center bg-white" aria-busy="true" aria-label="Cargando tienda">
          <div class="w-10 h-10 rounded-full border-4 border-gray-200 border-t-gray-500 animate-spin motion-reduce:animate-none"></div>
        </main>
      }
      @case ('unavailable') {
        <main class="min-h-screen flex items-center justify-center bg-gray-50 px-4">
          <div class="max-w-md text-center space-y-4">
            <div class="mx-auto w-14 h-14 rounded-2xl bg-gray-200 text-gray-500 flex items-center justify-center" aria-hidden="true">
              <svg class="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path d="M3 9l1-5h16l1 5M3 9h18M3 9v11h18V9M9 20v-6h6v6" /></svg>
            </div>
            <h1 class="text-2xl font-extrabold text-gray-900">Tienda no disponible</h1>
            <p class="text-sm text-gray-600">
              La tienda <strong class="font-mono">{{ storeConfig.currentSlug() }}</strong> no existe o todavía no está publicada.
              Revisa la dirección o vuelve más tarde.
            </p>
            <a routerLink="/" class="inline-flex text-sm font-semibold text-primary-600 hover:underline">Ver tiendas disponibles</a>
          </div>
        </main>
      }
      @case ('error') {
        <main class="min-h-screen flex items-center justify-center bg-gray-50 px-4">
          <div class="max-w-md text-center space-y-4" role="alert">
            <h1 class="text-2xl font-extrabold text-gray-900">No pudimos cargar la tienda</h1>
            <p class="text-sm text-gray-600">Hubo un problema de conexión. Intenta de nuevo en unos segundos.</p>
            <button
              type="button"
              (click)="retry()"
              class="inline-flex items-center rounded-full bg-primary-600 px-5 py-2.5 text-sm font-semibold text-white hover:opacity-90"
            >
              Reintentar
            </button>
          </div>
        </main>
      }
      @default {
        <div class="min-h-screen flex flex-col bg-white">
          <app-header />
          <main class="flex-1">
            <router-outlet />
          </main>
          <app-footer />
          <app-toast-container />
      <app-confirm-dialog />
        </div>
      }
    }
  `,
})
export class MainLayoutComponent implements OnInit {
  storeConfig = inject(StoreConfigService);
  private route = inject(ActivatedRoute);

  /** El subdominio manda en el navegador; si no, el :slug de la ruta (el único que ve el SSR). */
  ngOnInit(): void {
    this.storeConfig.enterStore(this.storeConfig.detectSlug() || this.route.snapshot.paramMap.get('slug') || '');
  }

  retry(): void {
    this.storeConfig.loadStoreConfig(undefined, true).subscribe();
  }
}
